module.exports = __webpack_public_path__ + "static/media/butt01.72b3d126.png";